module.exports = __webpack_public_path__ + "static/media/onboard3.2f0f775c.png";